import React from 'react';
import { useSelector } from 'react-redux';

const Dashboard = () => {
  const username = useSelector((state) => state.auth.username);
  const id = useSelector((state) => state.auth.id);
  const loid = useSelector((state) => state.auth.locationid);
  console.log('Redux state username:', username);

  return (
    <div>
      <h1>Welcome, {username || 'Guest'}!</h1>
      <h1>Welcome, {id || 'Guest'}!</h1>
      <h1>Welcome, {loid || 'Guest'}!</h1>


    </div>
  );
};

export default Dashboard;
